import { json } from "utils/http/client";

export const ProcurementApi = {
    // list all materials by site
    listMaterialRequests: (organisationId) =>
        json(`/inventory/material-requests/org/${organisationId}/`, {
            method: "GET",
        }),
    listPurchaseOrders: (organisationId) =>
        json(`/inventory/purchase-orders/org/${organisationId}/`, {
            method: "GET",
        }),
};
